/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/home',['require','./page','text!../../../views/home.html'],function(require) {

  var Page = require('./page');  
  var template = require('text!../../../views/home.html');

  return Page.extend({
	 template: _.template(template),
	 
	 afterRender: function() {
	     $('html').addClass('fullscreen');
	 },
	 
	 transitionOut: function(newPage){
	     $('html').removeClass('fullscreen');
         TweenMax.to(this.$el, 1, { alpha: 0, onComplete: this.transitionOutComplete, onCompleteScope: this });
     },
  });
});

